<template>
  <section id="hot-article">
    <div class="article-box">
      <h2>
        <!-- <span class="iconfont">&#xe61e;</span> -->
        {{ $t('hot-article.title') }}
      </h2>
      <div>
        <span @click="type=0" :class="['day',type===0?'active':'']">{{ $t('hot-article.rank-day') }}</span>
        |
        <span
          @click="type=1"
          :class="['week',type===1?'active':'']"
        >{{ $t('hot-article.rank-week') }}</span>
      </div>
    </div>
    <ul v-for="(items,index) in hotArticle" :key="index" :class="[type===index?'active':'']">
      <li v-for="(item,idx) in items" :key="idx">
        <i :class="[idx < 3? 'top' : '']">{{idx+1}}.</i>
        <a :href="$i18n.path(`p/${item.postId}`)" target="_blank">{{item.title}}</a>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      type: 0
    };
  },
  methods: {},

  computed: {
    hotArticle() {
      return this.$store.state.hotArticle;
    }
    // ...mapState({
    //   state: ({
    //     Login
    //   }) => Login,
    // }),
  }
};
</script>

<style lang="less" scoped>
#hot-article {
  width: 326px;
  background-color: #fff;
  padding: 22px;
  .article-box {
    border-bottom: 0.5px solid #e8e8e8;
  }
  div {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .iconfont {
      color: #478cf3;
      font-weight: 100;
      font-size: 20px;
    }
    h2 {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
    }

    div {
      font-size: 14px;

      span {
        padding: 0 15px;
        cursor: pointer;
      }

      .week {
        padding-right: 0;
      }

      .active {
        color: rgb(50, 120, 210);
      }
    }
  }

  ul {
    display: none;

    li {
      display: flex;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px dashed #999999;

      &:last-child {
        border-bottom: none;
        margin: 0;
      }

      i {
        font-size: 24px;
        color: #999999;
        font-style: italic;
        font-weight: 700;
      }

      .top {
        color: #222222;
      }

      a {
        font-size: 14px;
        color: #222222;
        line-height: 30px;
        margin-left: 5px;

        &:hover {
          color: rgb(50, 120, 210);
        }
      }
    }
  }

  .active {
    display: block;
  }
}
</style>
